import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const FIELDGROUP = {
  getAllFieldGroupList: {
    success: "FIELDGROUP_GET_ALL_SUCCESS",
    error: "FIELDGROUP_GET_ALL_ERROR"
  },
  create: {
    success: "FIELDGROUP_CREATE_SUCCESS",
    error: "FIELDGROUP_CREATE_ERROR"
  },
  edit: {
    success: "FIELDGROUP_EDIT_SUCCESS",
    error: "FIELDGROUP_EDIT_ERROR"
  },
  update: {
    success: "FIELDGROUP_UPDATE_SUCCESS",
    error: "FIELDGROUP_UPDATED_ERROR"
  },
  delete: {
    success: "FIELDGROUP_DELETE_SUCCESS",
    error: "FIELDGROUP_DELETE_ERROR"
  }
};

export const fieldGroupListAction = (harvestYear=harvestYearDetail().name) => {
  return (dispatch,getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
  let url = `/ntrac/fieldgroup/farmId/${
    userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
  }?harvestYear=${harvestYear}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = moment(item.updatedAt).format('ll');
          item.fields = item.fields.length || 0;
          item.indicators = item.indicators.length || 0;
        });
        dispatch({ type: FIELDGROUP.getAllFieldGroupList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createFieldGroupAction = fieldGroupInfo => {
  let url = `/ntrac/fieldgroup`;
  return dispatch => {
    globalApiHandler(url, "post", fieldGroupInfo)
      .then(response => {
        dispatch({ type: FIELDGROUP.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const grpEditAction = data => {
  return dispatch => {
    dispatch({ type: FIELDGROUP.edit.success, data });
  };
};

export const grpUpdateAction = fieldGroupInfo => {
  let url = `/ntrac/fieldgroup/${fieldGroupInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", fieldGroupInfo)
      .then(response => {
        dispatch({ type: FIELDGROUP.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteFieldGroupAction = id => {
  let url = `/ntrac/fieldgroup/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: FIELDGROUP.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/fieldgroups/action.js